import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastProvider } from "./providers/ToastProvider";
import {
  LicenseProvider,
  StepperProvider,
} from "./modules/UpgradeLicense/Context/LicenseProvider";
import { OptionsProvider } from "./providers/OptionsProvider";
import { ConfigProvider } from "./providers/ConfigProvider";
import { AuthProvider } from "./providers/AuthProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <ToastProvider>
        <ConfigProvider>
          <OptionsProvider>
            <LicenseProvider>
              <StepperProvider>
                <App />
              </StepperProvider>
            </LicenseProvider>
          </OptionsProvider>
        </ConfigProvider>
      </ToastProvider>
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
